// extracted by mini-css-extract-plugin
export var deliveryRow = "_oo-a";
export var fixedHeight = "_oo-4";
export var freightLogo = "_oo-9";
export var fullWidth = "_oo-3";
export var priceColumn = "_oo-5";
export var radioSelected = "_oo-7";
export var radioUnselected = "_oo-6";
export var selectedOption = "_oo-2";
export var selectedOptionContainer = "_oo-1";
export var selection = "_oo-0";
export var tallSkeletonText = "_oo-8";